import httpClient from "../../../client/httpClient";

const fetchCountries = async () => {
    try {
        const res = await httpClient.get("/v1/api/countries/get-all");
        return res.data || [];
    } catch (error) {
        console.error("Error fetching countries:", error);
        return [];
    }
};

const fetchDivisions = async (countryCode) => {
    try {
        if (!countryCode) return [];
        const res = await httpClient.get(`/v1/api/divisions/country/${countryCode}`);
        if (!res?.data) return [];

        if (countryCode === "01") {
            //TODO: Filtered by ko Phoe Cho (3 Oct 2024)
            const currentAllowedStateName = ["Yangon Region"];
            const filteredData = res.data.filter((division) =>
                currentAllowedStateName.includes(division.stateName.trim())
            );
            return filteredData;
        } else {
            return res.data;
        }
    } catch (error) {
        console.error("Error fetching divisions:", error);
        return [];
    }
};

const fetchDistricts = async ({ countryCode, divisionCode }) => {
    try {
        if (!divisionCode || !countryCode) return [];
        const res = await httpClient.get(
            `/v1/api/districts/division-and-country/${divisionCode}/${countryCode}`
        );
        return res.data || [];
    } catch (error) {
        console.error("Error fetching districts:", error);
        return [];
    }
};

const fetchTownships = async ({ countryCode, divisionCode }) => {
    try {
        if (!countryCode || !divisionCode) return [];

        const res = await httpClient.get(
            `/v1/api/townships/township-by-country-division-code/${countryCode}/${divisionCode}`
        );

        const townships = res.data || [];

        //TODO: Filtered by ko Phoe Cho (3 Oct 2024)
        const filtered = townships.filter((e) => {
            const townshipName = e.townshipName?.toLowerCase() || "";
            return !["seikkyikanaungto", "dala"].includes(townshipName);
        });

        return filtered;
    } catch (error) {
        console.error("Error fetching townships:", error);
        return [];
    }
};

export { fetchCountries, fetchDivisions, fetchDistricts, fetchTownships };
